export default __webpack_public_path__ + "6a50f0201b1973d0bb770ede83887bb9.svg";